<template>
  <div>
    <!-- BEGIN: Left Aside -->
    <div
      id="m_aside_left"
      class="m-grid__item	m-aside-left  m-aside-left--skin-dark "
    >
      <!-- BEGIN: Aside Menu -->
      <div
        id="m_ver_menu"
        class="m-aside-menu  m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark "
        :m-menu-vertical="'1'"
        :m-menu-scrollable="'1'"
        :m-menu-dropdown-timeout="'500'"
        style="position: relative;"
      />

      <!-- END: Aside Menu -->
    </div>
    <!-- END: Left Aside -->
  </div>
</template>

<script>
export default {
    data() {
        return {
            queryRoute: null,
        };
    },
    computed: {

    },
    mounted() {

    },

};
</script>
